import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { primarySoft } from '../../../../../../theme';

interface ToolPanelProps {
  icon: ReactNode;
  title: string;
  children: ReactNode;
}

function ToolPanel({ icon, title, children }: ToolPanelProps) {
  return (
    <Box sx={{ border: '1px solid', borderColor: theme => primarySoft(theme, 0.25), borderRadius: 2, p: 2, mb: 2, backgroundColor: theme => primarySoft(theme, 0.02) }}>
      <Typography variant="body2" fontWeight={700} sx={{ mb: 1.5, color: 'primary.main', display: 'flex', alignItems: 'center', gap: 0.75 }}>
        {icon} {title}
      </Typography>
      {children}
    </Box>
  );
}

export default ToolPanel;
